import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// The canonical dashboard host (issue #20). The Firebase default domains can't
// be detached from the Hosting site, so visits there bounce here instead —
// they're also removed from Auth's authorized domains, so sign-in only works
// on the canonical host (and localhost for dev).
const CANONICAL_HOST = 'agent-monitor.rocketable.ai';
const LEGACY_HOSTS = ['rocketable-agent-monitor.web.app', 'rocketable-agent-monitor.firebaseapp.com'];
if (LEGACY_HOSTS.includes(window.location.hostname)) {
  window.location.replace(`https://${CANONICAL_HOST}${window.location.pathname}${window.location.search}`);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
